import axiosInstance from 'api/axios';
import { APIResponse, BrandbookData, BrandbookResponse, GenerateBrandbookRequest, RegenerateSectionRequest, SaveBrandbookResponse, SaveBrandbookRequest } from '../types';

// Response Types


export const brandbookService = {
  // Generate complete brandbook
  generateBrandbook: async (
    data: GenerateBrandbookRequest
  ): Promise<APIResponse<BrandbookResponse>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/brandbook/generate-brandbook',
      data
    );
    return response.data;
  },

  // Regenerate specific section
  regenerateSection: async (request: RegenerateSectionRequest): Promise<APIResponse<{ regenerated_section: Partial<BrandbookData> }>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/brandbook/regenerate-brandbook-section',
      request
    );
    return response.data;
  },

  regenerateLogo: async (brandbook: BrandbookData, prompt: string) => {
    const response = await axiosInstance.private.post(
      '/api/v1/brandbook/regenerate-logo',
      {
        brandbook,
        prompt
      }
    );
    return response.data;
  },

  // Get brandbook by ID
  getBrandbookById: async (
    brandbook_id: number
  ): Promise<APIResponse<BrandbookResponse>> => {
    const response = await axiosInstance.private.get(`/api/v1/brandbook/id`, {
      params: {
        brandbook_id,
      },
    });
    return response.data;
  },

  // Get all brandbooks
  getAllBrandbooks: async (): Promise<APIResponse<BrandbookResponse[]>> => {
    const response = await axiosInstance.private.get('/api/v1/brandbook/all');
    return response.data;
  },

  // Get brandbooks by user ID
  getBrandbooksByUserId: async (
    userId: string
  ): Promise<APIResponse<BrandbookResponse[]>> => {
    const response = await axiosInstance.private.get(
      `/api/v1/brandbook/user_id?user_id=${userId}`
    );
    return response.data;
  },

  // Save brandbook
  saveBrandbook: async (
    displayName: string,
    data: SaveBrandbookRequest
  ): Promise<APIResponse<SaveBrandbookResponse>> => {
    const response = await axiosInstance.private.post(
      `/api/v1/brandbook/save-brandbook`,
      {
        display_name: displayName,
        brandbook: data
      }
    );
    return response.data;
  },
};

export default brandbookService;
